import { Navigate, Outlet } from 'react-router-dom'
import { useAuthStore, selectIsAuthenticated, selectUser } from '../stores/authStore'

/**
 * Wraps /onboarding. Rules:
 * - Not authenticated → /login
 * - Authenticated + already onboarded → /home
 * - Authenticated + not onboarded → render Outlet (OnboardingPage)
 */
export default function OnboardingRoute() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated)
  const user = useAuthStore(selectUser)

  if (!isAuthenticated) return <Navigate to="/login" replace />
  if (user?.onboarding_completed) return <Navigate to="/home" replace />

  return <Outlet />
}
